module.exports = __webpack_public_path__ + "files/b83ccfe9345845cccc1db1138c00c10d.png";